import React from "react";
import FileInput from "../../../components/form/FileInput";
import BaseModalAnimated from "../../../components/modal/BaseModalAnimated";
import { showFormErrors } from "../../../helpers/showFormErrors";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../components/form/CustomInput";
import CustomButton from "../../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { reset_evidence, update_load } from "../../../store/loads/action";

const UpFile = ({ evidences, modal, setModal, setEvidences }) => {
    const dispatch = useDispatch()
    const { evidence, validationsEvidence, load } = useSelector(state => state.Load)
    const validationDocument = useFormik({
        initialValues: evidence,
        validationSchema: Yup.object(validationsEvidence),
        onSubmit: async (values, { resetForm }) => {
            values.name = values.name_file_input
            values.id = values.id || `random-${Math.random().toString(36).substr(2, 9)}`
            values.base64= values.document
            values.document_format= values.document_format
            values.description= values.description || 'Sin descripción'

            setEvidences([...evidences, values])
            const evidenceDocuments = [...load.evidences, values]
            dispatch(update_load({ ...load, evidences:evidenceDocuments }))
            dispatch(reset_evidence())
            validationDocument.resetForm();
            setModal({ ...modal, show: false })
        },
    });

    return (
        <BaseModalAnimated modal={modal} setModal={setModal}>
            <form
                onSubmit={(e) => {
                    console.log(validationDocument.values, 'values')
                    e.preventDefault();
                    validationDocument.handleSubmit();
                    showFormErrors(validationDocument);
                    return false;
                }}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                    {modal.type === "camera" ? (
                        <></>
                    ) : (
                        <FileInput
                            validation={validationDocument}
                            format={modal.type}
                            name={"document"}
                            nameInput={"Evidence"}
                        />
                    )}

                    <CustomInput
                        label="Description"
                        type="text"
                        name="description"
                        labelClassName="text-xs font-medium text-cs-dark"
                        error={validationDocument?.errors?.description}
                        value={validationDocument?.values?.description}
                        handleChange={validationDocument.handleChange}
                    />
                </div>

                <div className="flex items-center justify-center p-4 rounded-b border-t border-cs-border">
                    <CustomButton
                        type={"submit"}
                        className="w-full md:w-[40%]"
                    >
                        Add evidence
                    </CustomButton>
                </div>
            </form>
        </BaseModalAnimated>
    );
};

export default UpFile;
